import React, { memo, useState } from "react";
import { Control, FieldError, UseFormSetValue, useWatch } from "react-hook-form";
import { OfferSaleType } from "../../../common/dataTypes/OfferSaleType";
import TextBoxWithQrScanner from "../../../components/ui/TextBoxWithQrScanner/TextBoxWithQrScanner";
import Button from "../../../components/ui/Button/Button";
import styles from "../OfferSale.module.scss";
import ValidationLabel from "../../../components/ui/ValidationLabel/ValidationLabel";
import { offerSaleErrors } from "../OfferSale";
import ReceiptPhotoField from "./ReceiptPhotoField";

import langs from "../../../common/services/languageService";
const {labels, validationMessages} = langs;

interface ScanDeviceProps {
	control: Control<OfferSaleType, any>;
	onQrScanned: (controlName: string, value: string) => void;
	onSubmit: () => void;
	setValue: UseFormSetValue<OfferSaleType>;
}

const ScanDevice: React.FC<ScanDeviceProps> = ({ control, onQrScanned, onSubmit, setValue }) => {
	const [comment, setComment] = useState("");
	const receiptPhoto = useWatch({ control, name: "receiptPhoto" });
	const isSubmitDisabled = !receiptPhoto;
	const serverError = offerSaleErrors.value.root?.serverError;
	return (
		<>
			<div className={styles.scanDevice}>
				<span>{labels.CustomerAlreadyRegistered()}</span>
				<span>{labels.ScanOrEnterTheQrCodeOfTheDevice()}</span>
				<TextBoxWithQrScanner 
					name="deviceQRCode" 
					label="Kod QR urządzenia" 
					control={control} 
					onQrScanned={onQrScanned} 
					showScannerByDefault 
					validationRule={{required: validationMessages.Required()}}
				/>
				<ReceiptPhotoField control={control} />
				<div className={styles.commentField}>
					<label htmlFor="scan-device-comment">{labels.OptionalCommentHint()}</label>
					<textarea
						id="scan-device-comment"
						value={comment}
						rows={5}
						onChange={(e) => {
							setComment(e.target.value);
							setValue("comment", e.target.value);
						}}
					/>
				</div>
			</div>
			<ValidationLabel asBigText centered error={serverError as FieldError} className={styles.paddingTop}/>
			<Button className={styles.submitButtonSpacing} disabled={isSubmitDisabled} onClick={onSubmit}>{labels.Confirm().toLowerCase()}</Button>
		</>
	);
};

export default memo(ScanDevice);
